import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import StudentLogin from './components/StudentLogin';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import StudentDashboard from './components/StudentDashboard';
import StudentManagement from './components/StudentManagement';
import CourseManagement from './components/CourseManagement';
import Layout from './components/Layout';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const HomeRedirect = () => {
  const { isAuthenticated, loading } = useAuth();
  const [studentToken, setStudentToken] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check for student token
    const token = localStorage.getItem('studentToken');
    setStudentToken(token);
    setChecking(false);
  }, []);

  if (loading || checking) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  // If admin is authenticated, redirect to admin dashboard
  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  // If student token exists, redirect to student dashboard
  if (studentToken) {
    return <Navigate to="/student/dashboard" replace />;
  }

  // If neither authenticated, show student login
  return <StudentLogin />;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/admin/ssodlmanagment2201" element={<Login />} />
      <Route path="/:prn/reset-password" element={<ResetPassword />} />
      <Route path="/student/login" element={<StudentLogin />} />
      <Route path="/student/dashboard" element={<StudentDashboard />} />
      <Route
        path="/students"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<StudentManagement />} />
      </Route>
      <Route
        path="/courses"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<CourseManagement />} />
      </Route>
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="students" element={<StudentManagement />} />
        <Route path="courses" element={<CourseManagement />} />
      </Route>
    </Routes>
  );
}

export default App;